import React from "react";
import { Check } from "lucide-react";
import { WEEKLY, SHOTS } from "../mock";
import DeviceFrame from "./renn/DeviceFrame";
import Reveal from "./Reveal";

const WeeklyCheckin = () => {
  return (
    <section className="relative py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal delay={100} className="order-2 lg:order-1 flex justify-center lg:justify-start">
          <DeviceFrame src={SHOTS.weekly} alt="Renn weekly check-in screen" className="w-full max-w-[360px]" />
        </Reveal>

        <Reveal className="order-1 lg:order-2">
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Weekly check-in</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {WEEKLY.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8] leading-relaxed">{WEEKLY.copy}</p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {WEEKLY.highlights.map((h) => (
              <li key={h} className="flex items-center gap-3 rounded-xl border border-[#29354A] bg-[#121A28] px-4 py-3">
                <span className="w-6 h-6 rounded-full bg-[#10C98A]/15 flex items-center justify-center shrink-0">
                  <Check className="w-3.5 h-3.5 text-[#13D99A]" />
                </span>
                <span className="text-[#F5F7FB] text-sm">{h}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default WeeklyCheckin;
